module.exports = __webpack_public_path__ + "img/1970East-038_WEB-min.716f4117.jpg";